import React from 'react';
import { IResortPageSnowInfo, IContactInformation } from '@/api/resort/types';
import { useOTSTranslation } from '@/i18n/useOTSTranslation';
import GoogleApiWrapper from '../ContactInformation/GoogleApiWrapper';
import { SectionHeader } from '../SectionHeader';

interface Props {
  description?: { dangerouslySetInnerHTML: { __html: string; }; };
  country: string;
  city: string;
  fullResort: IResortPageSnowInfo;
  contactInformation: IContactInformation;
  isSummerMode?: boolean;
  adSlot?: React.ReactNode;
}

export const HowToGetThereSection = ({
  description, country, city, fullResort, contactInformation, isSummerMode = false, adSlot,
}: Props) => {
  const { t } = useOTSTranslation('common');

  return (
    <section>
      <SectionHeader
        title={t('resort.overview.transportationTab')}
        description={description}
        isSummerMode={isSummerMode}
      />
      {adSlot}
      <div className="h-[292px] rounded-[20px] overflow-hidden">
        <GoogleApiWrapper
          place={`${country} ${city} ${fullResort.title}`}
          lat={contactInformation.address.lat}
          lng={contactInformation.address.lng}
        />
      </div>
    </section>
  );
};
